class Callbacks {
    set(object, key, oldValue, newValue) {
        throw new Error("Method .set is not implemented");
    }

    delete(object, key, oldValue) {
        throw new Error("Method .delete is not implemented");
    }
}

export default Callbacks;
